import React from "react";
import loadingIcon from "./../../img/icons/Loading-icon.svg";
import "./style.css";

export const LoadingIcon = (props) => {
  return (
    <img
      className="rotate"
      width={props.width ?? "24"}
      height={props.height ?? "24"}
      src={loadingIcon}
      key={"loading"}
      alt={"Loader"}
    />
  );
};